import { CoralogixRum } from '@coralogix/browser';
import { IUserInfo } from 'types';

const supportedEnvironments = ['production', 'preprod', 'theory'];

export type TRumUser = Pick<IUserInfo, 'id' | 'email' | 'first_name' | 'last_name'>;

export const setupRUM = (client: TRumUser) => {
    const environment = import.meta.env.VITE_APP_ENV;
    const publicKey = import.meta.env.VITE_APP_CORALOGIX_PUBLIC_KEY;

    if (!publicKey || !supportedEnvironments.includes(environment)) {
        return;
    }

    CoralogixRum.init({
        public_key: publicKey,
        application: 'cdm-dashboard',
        version: import.meta.env.VITE_APP_VERSION,
        environment,
        coralogixDomain: 'EU2',
        stringifyCustomLogData: true,
    });

    if (client.id == null) {
        return;
    }

    CoralogixRum.setUserContext({
        user_email: client.email,
        user_id: String(client.id),
        user_name: `${client.first_name} ${client.last_name}`,
    });
};
